import "flowbite";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { BlurScrollEffect } from "./BlurScrollEffect";
gsap.registerPlugin(ScrollTrigger, SplitText);

/** 
**************************************************
Smooth Scrolling.
**************************************************
*/
const initSmoothScroll = () => {
  const lenis = new Lenis();
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
};
/** 
**************************************************
Animated Paws.
**************************************************
*/
const animatePaws = () => {
  let paws = gsap.utils.toArray(".js-paws");
  if (paws) {
    paws.forEach((paw, i) => {
      gsap.set(paw, { rotate: i % 2 == 0 ? "10deg" : "170deg" });
      if (paw.anim) {
        paw.anim.progress(1).kill();
      }
      let pawPrints = gsap.utils.toArray("g", paw);
      paw.anim = gsap.from(pawPrints, {
        scrollTrigger: {
          trigger: paw,
          start: "top top+=75%",
          end: "top center",
        },
        duration: 2,
        willChange: "transform, opacity",
        transformOrigin: "top bottom",
        ease: "elastic.out",
        scale: 0.5,
        opacity: 0,
        stagger: { each: 0.05, from: "start" },
      });
    });
  }
};
/** 
**************************************************
Animated Sections.
**************************************************
*/
const animateSections = () => {
  let sections = gsap.utils.toArray("section");
  if (sections) {
    sections.forEach((s, i) => {
      if (s.anim) {
        s.anim.progress(1).kill();
      }
      s.anim = gsap.from(s, {
        scrollTrigger: {
          trigger: s,
          start: "top top+=90%",
          end: "top center",
        },
        duration: 0.6,
        willChange: "transform, opacity",
        transformOrigin: "top bottom",
        ease: "power1.out",
        y: 32,
        opacity: 0,
      });
    });
  }
};
/** 
**************************************************
Carousels.
**************************************************
*/
const carousel = () => {
  if (document.querySelector(".mySwiper")) {
    let swiper = new Swiper(".mySwiper", {
      modules: [Navigation, Autoplay],
      loop: true,
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
};
/** 
**************************************************
DOM ready.
**************************************************
*/
window.addEventListener("load", (e) => {
  document.body.classList.remove("loading");
  initSmoothScroll();
  animatePaws();
  carousel();
  animateSections();
  document
    .querySelectorAll(["h1", "h2", "h3"])
    .forEach((el) => new BlurScrollEffect(el));
});
